import React, { useState } from 'react';
import { StyleSheet, View, ScrollView, Linking } from 'react-native';
import NavigateRow from '../../NavigateRow';
import ExpandableContent from './ExpandableContent';
import BaseText from '../../BaseText';
import { Screens } from '../../../constants/ScreenNames';
import { CommonStyles, CommonProperties, Color } from '../../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../../i18n';
import { companyEmails } from '../../../constants/Enums';
import { AA_ENABLED } from '../../../config/env';

const BaseTextEmail = ({ email }) => {
  return (
    <BaseText onPress={() => Linking.openURL('mailto:' + email)} style={styles.link}>
      {email}
    </BaseText>
  );
};

const TermsModal = (props) => {
  const { tKey } = useComponentTKey('TermsModal');
  const { t } = useTranslation(i18nNS.settings);
  const [agreementViewerVisible, setAgreementVisible] = useState(false);
  const [useOfWebVisible, setUseOfWebsiteVisible] = useState(false);
  const [termViewerVisible, setTermVisible] = useState(false);
  const [prohobitedViewerVisible, setProhobitedVisible] = useState(false);
  const [pricingViewerVisible, setPricingViewerVisible] = useState(false);
  const [transactionViewerVisible, setTransactionViewerVisible] = useState(false);
  const [feeViewerVisible, setFeeViewerVisible] = useState(false);
  const [supplierViewerVisible, setSupplierViewerVisible] = useState(false);
  const [hotelViewerVisible, setHotelViewerVisibleVisible] = useState(false);
  const [travelViewerVisible, setTravelViewerVisible] = useState(false);
  const [bankViewerVisible, setBankViewerVisible] = useState(false);
  const [linksViewerVisible, setLinksViewerVisible] = useState(false);
  const [softwareViewerVisible, setSoftwareViewerVisible] = useState(false);
  const [copyrightViewerVisible, setCopyrightViewerVisible] = useState(false);
  const [noticeViewerVisible, setNoticeViewerVisible] = useState(false);
  const [accountViewerVisible, setAccountViewerVisible] = useState(false);
  const [disclaimerViewerVisible, setDisclaimerViewerVisible] = useState(false);
  const [indemnificationViewerVisible, setIndemnificationViewerVisible] = useState(false);
  const [privacyViewerVisible, setPrivacyViewerVisible] = useState(false);
  const [serviceViewerVisible, setServiceViewerVisible] = useState(false);

  const [generalViewerVisible, setGeneralViewerVisible] = useState(false);

  const onAgreementPress = () => {
    setAgreementVisible(!agreementViewerVisible);
  };
  const onUseOfWebsitePress = () => {
    setUseOfWebsiteVisible(!useOfWebVisible);
  };
  const onTermPress = () => {
    setTermVisible(!termViewerVisible);
  };
  const onProhobitedPress = () => {
    setProhobitedVisible(!prohobitedViewerVisible);
  };
  const onPricingPress = () => {
    setPricingViewerVisible(!pricingViewerVisible);
  };
  const onTransactionPress = () => {
    setTransactionViewerVisible(!transactionViewerVisible);
  };
  const onFeePress = () => {
    setFeeViewerVisible(!feeViewerVisible);
  };
  const onSupplierPress = () => {
    setSupplierViewerVisible(!supplierViewerVisible);
  };
  const onLinksPress = () => {
    setLinksViewerVisible(!linksViewerVisible);
  };
  const onTravelPress = () => {
    setTravelViewerVisible(!travelViewerVisible);
  };
  const onBankPress = () => {
    setBankViewerVisible(!bankViewerVisible);
  };
  const onHotelPress = () => {
    setHotelViewerVisibleVisible(!hotelViewerVisible);
  };
  const onSoftwarePress = () => {
    setSoftwareViewerVisible(!softwareViewerVisible);
  };
  const onCopyRightPress = () => {
    setCopyrightViewerVisible(!copyrightViewerVisible);
  };
  const onServicePress = () => {
    setServiceViewerVisible(!serviceViewerVisible);
  };
  const onNoticePress = () => {
    setNoticeViewerVisible(!noticeViewerVisible);
  };
  const onAccountPress = () => {
    setAccountViewerVisible(!accountViewerVisible);
  };
  const onDisclaimerPress = () => {
    setDisclaimerViewerVisible(!disclaimerViewerVisible);
  };
  const onIndemnificationtPress = () => {
    setIndemnificationViewerVisible(!indemnificationViewerVisible);
  };
  const onPrivacytPress = () => {
    setPrivacyViewerVisible(!privacyViewerVisible);
  };
  const onGeneralPress = () => {
    setGeneralViewerVisible(!generalViewerVisible);
  };
  const siteURL = AA_ENABLED ? 'www.business.aa.com' : 'www.tripeasy.com';
  return (
    <View style={{ flex: 1 }}>
      <ScrollView>
        <BaseText style={styles.footer}>{t(tKey('UpdatedDate'))}</BaseText>
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('AgreementTitle'))}
          onPressCallback={onAgreementPress}
        />
        {agreementViewerVisible && (
          <ExpandableContent>
            <BaseText>
              {t(tKey('AssistCustomers1'))}
              {siteURL}
              {t(tKey('AssistCustomers2'))}
            </BaseText>
            <BaseText style={styles.subtitle}>
              <BaseText>{t(tKey('WebsiteUsageCondition'))}</BaseText> {/*I found repeated text*/}
              <BaseText style={styles.bolder}>{t(tKey('PleaseRead'))}</BaseText>
              <BaseText
                onPress={() => props.navigation.navigate(Screens.Privacy)}
                style={styles.link}
              >
                {t(tKey('PrivacyPolicy'))}
              </BaseText>
              <BaseText style={styles.bolder}>{t(tKey('PrivacyInfo'))}</BaseText>
              {t(tKey('PrivacyAgreements'))}
            </BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('UseoftheWebsite'))}
          onPressCallback={onUseOfWebsitePress}
        />
        {useOfWebVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('ConditionToUse'))}</BaseText>
            <BaseText>1 {t(tKey('CustomerUnderTravel'))}</BaseText>
            <BaseText>2 {t(tKey('PresenceOfAgreement'))}</BaseText>
            <BaseText>3 {t(tKey('AgeCondition'))}</BaseText>
            <BaseText>4 {t(tKey('LegalAuthority'))}</BaseText>
            <BaseText>5 {t(tKey('AccordanceOfTerms'))}</BaseText>
            <BaseText>6 {t(tKey('LegitimateReservations'))}</BaseText>
            <BaseText>7 {t(tKey('ValidInformation'))}</BaseText>
            <BaseText>8 {t(tKey('CustomerCompliance'))}</BaseText>
            <BaseText>
              9 {t(tKey('SelfResponsible1'))}
              {siteURL}
              {t(tKey('SelfResponsible2'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('RetainRightCondition'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('Term'))}
          onPressCallback={onTermPress}
        />
        {termViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('SubjectToTravelInfo'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('ProhobitedActivites'))}
          onPressCallback={onProhobitedPress}
        />
        {prohobitedViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('ProprietaryInfo'))}</BaseText>
            <BaseText>1 {t(tKey('CommercialUsage'))}</BaseText>
            <BaseText>2 {t(tKey('FraudReservtion'))}</BaseText>
            <BaseText>3 {t(tKey('AccessInfoUsingRobots'))}</BaseText>
            <BaseText>4 {t(tKey('VoilationInfo'))}</BaseText>
            <BaseText>5 {t(tKey('ImposingAction'))}</BaseText>
            <BaseText>6 {t(tKey('DeepLink'))}</BaseText>
            <BaseText>7 {t(tKey('MirrorPartOfWebsite'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('CancelReservation'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('Pricing'))}
          onPressCallback={onPricingPress}
        />
        {pricingViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('LinksToOtherWebsite'))}</BaseText>
            <View style={styles.row}>
              <View style={styles.column}>
                <BaseText style={styles.bolder}>Transactions</BaseText>
              </View>
              <View style={styles.column}>
                <BaseText style={styles.bolder}>Fee</BaseText>
              </View>
            </View>
            <View style={styles.row}>
              <View style={styles.column}>
                <BaseText>Agent</BaseText>
                <BaseText>Assistance</BaseText>
                <BaseText>Cancellation</BaseText>
                <BaseText>Surcharge</BaseText>
              </View>
              <View style={styles.column}>
                <BaseText>$25.00 USD per Agent Assisted Transaction</BaseText>
                <BaseText>$25.00 USD per Agent Assisted Cancellation Transaction</BaseText>
                <BaseText>$5.00 USD per Applicable Online Booking</BaseText>
                <BaseText>
                  or equivalent alternate currency amount if a denomination other than USD is
                  offered or required.
                </BaseText>
              </View>
            </View>
            <BaseText style={CommonStyles.my3}>
              <BaseText style={styles.bolder}>{t(tKey('AgentTransaction1'))}</BaseText>
              {t(tKey('AgentTransaction2'))}
              <BaseText style={styles.bolder}>{t(tKey('AgentTransaction3'))}</BaseText>
              {t(tKey('AgentTransaction4'))}
              <BaseText style={styles.bolder}>{t(tKey('AgentTransaction5'))}</BaseText>
              {t(tKey('AgentTransaction6'))}
              {t(tKey('AgentTransaction7'))}
              {t(tKey('AgentTransaction8'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('AgentSurcharge1'))}
              <BaseText style={styles.bolder}>{t(tKey('AgentSurcharge2'))}</BaseText>
              {t(tKey('AgentSurcharge3'))}
              <BaseText style={styles.bolder}>{t(tKey('AgentSurcharge4'))}</BaseText>
              {t(tKey('AgentSurcharge5'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('PaymentModes'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('SupplierTitle'))}
          onPressCallback={onSupplierPress}
        />
        {supplierViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('ReviewTermsBold'))}</BaseText>
              {t(tKey('ReviewTermsNormal'))}
            </BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('CustomerOpportunity'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('PriceConversion'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ComplyWithLaws'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('Acknowledgement'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('NotLiableInfo'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('PrepaidHotel'))}
          onPressCallback={onHotelPress}
        />
        {hotelViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>{t(tKey('CustomerAcknowledge'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ITSDoNotColectTax'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('CancellationCharges'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('PayCancellationAgreement'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('SalesInfo'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('PaymentOncheckIn'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('InternationalTravel'))}
          onPressCallback={onTravelPress}
        />
        {travelViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>{t(tKey('ForeignEntryRequiremnets'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('HealthRecommendations'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ReservationTravel'))}</BaseText>
            {AA_ENABLED && <BaseText style={CommonStyles.my2}>{t(tKey('SomeBanks'))}</BaseText>}
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'9. ' + t(tKey('BankAndCreditCard'))}
          onPressCallback={onBankPress}
        />
        {bankViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('ExtraFee'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'10. ' + t(tKey('LinksToThirdPary'))}
          onPressCallback={onLinksPress}
        />
        {linksViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('ContainesHyperLink'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'11. ' + t(tKey('SoftwareAvailable'))}
          onPressCallback={onSoftwarePress}
        />
        {softwareViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>
              {t(tKey('SoftwareDownload1'))}
              <BaseText style={styles.bolder}>{t(tKey('SoftwareDownload2'))}</BaseText>
              {t(tKey('SoftwareDownload3'))}
              <BaseText style={styles.bolder}>{t(tKey('SoftwareDownload4'))}</BaseText>
              {t(tKey('SoftwareDownload5'))}
            </BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('SoftwarePermission'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('SoftwareCopyingInfo'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('InternetConnection'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={t(tKey('CopyrightAndTrademarkNotices'))}
          onPressCallback={onCopyRightPress}
        />
        {copyrightViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>{t(tKey('RegisteredTrademarks'))}</BaseText>
            <BaseText style={CommonStyles.my2}>
              {t(tKey('InfringementInfo'))}
              <BaseTextEmail email={companyEmails.info} />.
            </BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'13. ' + t(tKey('NoticeOfInfringingMaterial'))}
          onPressCallback={onNoticePress}
        />
        {noticeViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>{t(tKey('MisrepresentationsInfo'))}</BaseText>
            <BaseText>1. {t(tKey('CopyrightIdentification'))}</BaseText>

            <BaseText>2. {t(tKey('MaterialIdentification'))}</BaseText>

            <BaseText>3. {t(tKey('ContactInfo'))}</BaseText>

            <BaseText>4. {t(tKey('TrustStatement'))}</BaseText>

            <BaseText>5. {t(tKey('NoticationInformation'))}</BaseText>

            <BaseText>6. {t(tKey('ActInfringed'))}</BaseText>
            <BaseText style={CommonStyles.my2}>
              {t(tKey('NoticeByEmail1'))}
              <BaseTextEmail email={companyEmails.copyright} />
              {t(tKey('NoticeByEmail2'))}
            </BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'14. ' + t(tKey('AccountTermination'))}
          onPressCallback={onAccountPress}
        />
        {accountViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('ApplicableLaw'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'15. ' + t(tKey('LiabilityDisclaimer'))}
          onPressCallback={onDisclaimerPress}
        />
        {disclaimerViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('PartnerAffliates'))}</BaseText>
            </BaseText>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('RatingsDisplayed'))}</BaseText>
            </BaseText>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('ITSAffiliates'))}</BaseText>
            </BaseText>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('IndependentContractorsInfo'))}</BaseText>
            </BaseText>
            <BaseText style={CommonStyles.my2}>
              <BaseText style={styles.bolder}>{t(tKey('ITSLiablity'))}</BaseText>
            </BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('AffiliateLiablity'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('LiabilityLimitations'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'16. ' + t(tKey('Indemnification'))}
          onPressCallback={onIndemnificationtPress}
        />
        {indemnificationViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('AgreeToIndemnify'))}</BaseText>
          </ExpandableContent>
        )}

        <NavigateRow
          style={styles.navigateRow}
          text={'17. ' + t(tKey('PrivacyPolicy'))}
          onPressCallback={onPrivacytPress}
        />
        {privacyViewerVisible && (
          <ExpandableContent>
            <BaseText>
              {t(tKey('LinkToPrivacy'))}
              <BaseText
                onPress={() => props.navigation.navigate(Screens.PrivacyPolicy)}
                style={styles.link}
              >
                {t(tKey('PrivacyPolicy'))}
              </BaseText>
            </BaseText>
          </ExpandableContent>
        )}

        <NavigateRow
          style={styles.navigateRow}
          text={'18.' + t(tKey('General'))}
          onPressCallback={onGeneralPress}
        />
        {generalViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my2}>{t(tKey('ChangeOfTerms'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('TermsGoverned'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('JointVentureAgreemnent'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('AgreementPerformnace'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ValidityOfAgreement'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('AllAgreementInfo'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ComnpanyNameInfo'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('CustomerITSCooperate'))}</BaseText>
            <BaseText style={CommonStyles.my2}>{t(tKey('ReservedRights'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow
          style={styles.navigateRow}
          text={'19. ' + t(tKey('Service'))}
          onPressCallback={onServicePress}
        />
        {serviceViewerVisible && (
          <ExpandableContent>
            <BaseText>
              {t(tKey('QuickSupport'))}
              <BaseTextEmail email={companyEmails.support} />.
            </BaseText>
          </ExpandableContent>
        )}
        <BaseText style={styles.footer}>{t(tKey('Fotter'))}</BaseText>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  navigateRow: {
    height: 50,
  },
  footer: {
    textAlign: 'center',
  },
  subtitle: {
    ...CommonProperties.pt2,
  },
  link: {
    color: Color.primary,
  },
  bolder: {
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.mx3,
    ...CommonProperties.mt3,
  },
  column: { width: '45%' },
});

export default TermsModal;
